import React from "react";
import { Link } from "react-router-dom";

const PrintModal = (props) => {
  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id="print" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>طباعة </h3>
                <p>خدمة الطباعة غير متوفرة في النسخة المجانية ! </p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  {/* <div className="col-6">
                    <Link to="#" className="btn btn-primary continue-btn">
                      اغلاق
                    </Link>
                  </div> */}
                  <div className="col-6">
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                    >
                      اغلاق
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default PrintModal;
